export default __webpack_public_path__ + "static/media/dashboardResponsive_en.46a24d12.png";